export const errorMessages = {
  EMAIL_ALREADY_EXISTS: 'This email address is already registered',
  USERNAME_ALREADY_EXISTS: 'Username is taken. Please try another',
  TOO_SHORT: 'Invalid phone number, too short.',
  'The phone number must be a non-empty E.164 standard compliant identifier string.':
    'Phone number must be in E.164 standard.',
  TOO_LONG: 'Invalid phone number, too long.'
};
